import { Box, Typography, Paper, Button, CircularProgress } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";

const ExpenseDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const apiUrl = "https://oven-backend.onrender.com";


  const [expense, setExpense] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExpense = async () => {
      try {
        const response = await axios.get(`${apiUrl}/expenses/${id}`);
        setExpense(response.data);
      } catch (error) {
        console.error("Error fetching expense:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchExpense();
  }, [id]);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box m="20px" sx={{ direction: isRTL ? "rtl" : "ltr" }}>
      <Typography variant="h4" fontWeight="bold">
        {t("expense_details")} 🧾
      </Typography>

      <Box
        mt={2}
        p={2}
        component={Paper}
        elevation={3}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography>{t("employee")}: {expense.employee_id?.name || "N/A"}</Typography>
        <Typography>{t("category")}: {expense.category}</Typography>
        <Typography>{t("amount")}: ${expense.amount}</Typography>
        <Typography>{t("date")}: {new Date(expense.date).toLocaleDateString()}</Typography>
        <Typography>{t("description")}: {expense.description}</Typography>
      </Box>

      <Box mt={3} display="flex" gap={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<EditIcon />}
          onClick={() => navigate(`/UpdateExpenses/${id}`)}
          sx={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          {t("edit_expense")}
        </Button>

          sx={{ display: "flex", alignItems: "center", gap: "8px" }}
          <Button variant="contained" color="secondary"
           startIcon={<PrintIcon />} onClick={() => window.print()}>
          {t("print_expense")}
        </Button>

        <Button variant="contained" color="success"
          sx={{ display: "flex", alignItems: "center", gap: "8px" }}
        startIcon={<PictureAsPdfIcon />}>
          {t("download_pdf")}
        </Button>
      </Box>
    </Box>
  );
};

export default ExpenseDetails;
